export default {
  badgeReact: {
    remove: 'Remove',
  },
};
